import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { StakingProcess, StakingActionType } from "@modules/staking/domain/entities/staking-process.model";
import { Fiat } from "@models";
import { Observable } from "rxjs";
import { StakingFacade } from "@modules/staking/domain/+state/staking.facade";
import { TradeAmountType } from "@modules/shared/domain/entities/trade-amount-type.model";
import { AnimationOptions } from "ngx-lottie";
import { StakingHelperService } from "@modules/staking/domain/+state/utility/staking-helper.service";

@Component({
	selector: "app-stake-success-screen",
	templateUrl: "./success-screen.component.html",
	styleUrls: ["./success-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SuccessScreenComponent {
	@Input() public defaultFiat: Fiat = this.stakingHelperService.getFiat();
	public stakingProcess$: Observable<StakingProcess> = this.stakingFacade.getStakingProcess$();
	public stakeType: StakingActionType = StakingActionType.STAKE;
	public tradeAmountTypes = TradeAmountType;

	public successAnimationOptions: AnimationOptions = {
		path: "https://bitpanda-broker-staging-assets.s3.eu-west-1.amazonaws.com/animations/success.json"
	};

	public constructor(
		private stakingFacade: StakingFacade,
		private stakingHelperService: StakingHelperService
	) {}
}
